import dayjs from 'utils/dayjs'

import locales from './data'

Object.keys(locales).forEach((locale) => {
  dayjs.updateLocale(locale.replace('_', '-'), { ...locales[locale] })
})
